var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},_vm._l((_vm.items),function(item){return _c('div',{key:item.name,staticClass:"tile"},[_c('img',{staticClass:"devicon-img",attrs:{"title":item.prettyName,"src":`https://cdn.jsdelivr.net/gh/devicons/devicon/icons/${item.name}/${item.fileName}.svg`}}),_c('p',[_vm._v(" "+_vm._s(item.prettyName)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }